import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import SegmentNameValidation from 'donor-elf-web/validations/journal/segment-name';

interface JournalSegmentsInfoArgs {
  allSegments: string[];
  filterSegment: string; //the current segment being filtered, if any
  onToggleFilter: (segment: string) => void;
  onEditSegment: (segment: string) => void;
}

export default class JournalSegmentsInfoComponent extends Component<JournalSegmentsInfoArgs> {
  constructor(owner: any, args: JournalSegmentsInfoArgs) {
    super(owner, args);
    this.createNewSegmentChangeset();
  }

  @tracked showValidationErrors = false;
  @tracked newSegmentChangeset?: any;

  createNewSegmentChangeset() {
    this.newSegmentChangeset = new Changeset(
      { name: '' },
      lookupValidator(SegmentNameValidation),
      SegmentNameValidation,
    );
  }

  @action
  handleDropdownClose() {
    this.showValidationErrors = false;
    this.createNewSegmentChangeset();
  }

  @action
  async handleSaveNewSegment(mainDropdown: any) {
    await this.newSegmentChangeset.validate();
    if (this.newSegmentChangeset.get('isValid')) {
      let segmentName = this.newSegmentChangeset.get('name');
      mainDropdown.actions.close();
      this.args.onEditSegment(segmentName);
      this.createNewSegmentChangeset();
    } else {
      this.showValidationErrors = true;
    }
  }
}
